"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasChineseCharacter = exports.has = exports.notEmpty = exports.notFalsy = exports.isSameArray = void 0;
const lodash_orderby_1 = __importDefault(require("lodash.orderby"));
const isSameArray = (array1, array2) => {
    if (array1.length !== array2.length) {
        return false;
    }
    const sortedA = (0, lodash_orderby_1.default)(array1);
    const sortedB = (0, lodash_orderby_1.default)(array2);
    return sortedA.every((value, index) => value === sortedB[index]);
};
exports.isSameArray = isSameArray;
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
const notFalsy = (value) => Boolean(value);
exports.notFalsy = notFalsy;
const notEmpty = (value) => value !== null && value !== undefined;
exports.notEmpty = notEmpty;
const has = (data, property) => Object.prototype.hasOwnProperty.call(data, property);
exports.has = has;
const hasChineseCharacter = (string) => Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));
exports.hasChineseCharacter = hasChineseCharacter;
